<template>
  <div class="home">
    <div class="news">
      <p class="title">
        <img
          class="title-image left"
          src="@/assets/images/title-left.png"
          alt=""
        />
        <span>新闻动态</span>
        <img
          class="title-image right"
          src="@/assets/images/title-right.png"
          alt=""
        />
      </p>
      <p class="titleEN">Latest News</p>
      <div class="bottom">
        <div class="news-image">
          <el-carousel height="420px" indicator-position="none">
            <el-carousel-item
              v-for="(item, index) in carouselList"
              :key="index"
              style="cursor: pointer"
            >
              <a
                @click="more('/news/list', item.nbId, true)"
                style="height: 70%; overflow: hidden; display: block"
                ><img :src="item.nbcImg" width="100%" :alt="item.noticeTitle"
              /></a>
              <p
                class="news-image-title"
                @click="more('/news/list', item.nbId, true)"
              >
                {{ item.noticeTitle }}
              </p>
              <p
                class="news-image-content"
                @click="more('/news/list', item.nbId, true)"
              >
                {{ item.content }}
              </p>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="news-list">
          <ul class="news-list-title">
            <li
              :class="newsAction == 1 ? 'is-action' : ''"
              @click="newListClick(1)"
            >
              专委新闻
            </li>
            <li
              :class="newsAction == 2 ? 'is-action' : ''"
              @click="newListClick(2)"
            >
              行业动态
            </li>
            <li
              :class="newsAction == 3 ? 'is-action' : ''"
              @click="newListClick(3)"
            >
              政策新闻
            </li>
          </ul>
          <div class="news-list-content">
            <template v-if="newsInfo.length">
              <a
                v-for="(item, key) in newsInfo"
                :key="key"
                @click="more('/news/list', item.nbId)"
              >
                <p>{{ item.nbTitle }}</p>
                <p>{{ formatDate(item.nbVisittime) }}</p>
              </a>
            </template>
            <div v-else class="no-data-wrap">
              <el-empty description="暂无数据">
                <template slot="image">
                  <img class="no-data-image" src="@/assets/images/no-data.svg" alt="">
                </template>
              </el-empty>
            </div>
          </div>
        </div>
      </div>
      <div
        class="news-more"
        @click="
          more(
            newsAction == 1
              ? '/news/list'
              : newsAction == 2
              ? '/news/notice'
              : '/news/policyNews'
          , '', true)
        "
      >
        查看更多
      </div>
    </div>
    <!-- end news -->
    <div class="tools">
      <p class="title">
        <img
          class="title-image left"
          src="@/assets/images/title-left.png"
          alt=""
        />
        <span>技术专区</span>
        <img
          class="title-image right"
          src="@/assets/images/title-right.png"
          alt=""
        />
      </p>
      <p class="titleEN">Technical Zone</p>
      <div class="bottom">
        <div class="query">
          <div class="query-img">
            <a :class="{'is-active': activeId == 1}" href="javascript:void(0)" @click="goWarn(1)">
              <div class="media">
                <svg-icon class-name="icon" icon-class="zszl-icon" />
              </div>
              <p>知识专区</p>
              <svg-icon class-name="image" icon-class="zszl-bg" />
            </a>
            <a :class="{'is-active': activeId == 2}" href="javascript:void(0)" @click="goWarn(2)">
              <div class="media">
                <svg-icon class-name="icon" icon-class="zlk-icon" />
              </div>
              <p>资料库</p>
              <svg-icon class-name="image" icon-class="zlk-bg" />
            </a>
            <a :class="{'is-active': activeId == 3}" href="javascript:void(0)" @click="goWarn(3)">
              <div class="media">
                <svg-icon class-name="icon" icon-class="scbk-icon" />
              </div>
              <p>数存百科</p>
              <svg-icon class-name="image" icon-class="scbk-bg" />
            </a>
          </div>
          <!-- <div class="query-tool">
              <span class="query-tool-check"></span>
              <span></span>
            </div> -->
        </div>
        <div class="query notice" v-if="activeId == 1">
          <!-- <h3>
            <img
              src="../assets/images/icon_notice.png"
              width="28"
              alt=""
            />公告栏
            <div class="more" @click="more('/news/notice')">更多</div>
          </h3> -->
          <div class="notice-content" @click="moreKb('/kb/doc')">
            <img class="image" src="@/assets/images/xjclBg.png" alt="" />
            <h3>先进存力系列专题</h3>
            <!-- <router-link
              v-for="(item, key) in newsNotice"
              :key="key"
              :to="'/news/detail?nId=' + item.nbId"
              tag="a"
              target="_blank"
            >
              <span>{{ item.nbTitle }}</span>
              <span>{{ formatDate(item.date) }}</span>
            </router-link> -->
            <div class="images">
              <img src="@/assets/images/technology1.png" alt="" />
              <img src="@/assets/images/technology2.png" alt="" />
              <img src="@/assets/images/technology3.png" alt="" />
            </div>
          </div>
        </div>
        <div class="query notice" v-if="activeId == 2">
          <img @click="moreKb('/kb/term')" class="notice-bg" src="@/assets/images/zlk-media.jpg" alt="">
        </div>
        <div class="query notice" v-if="activeId == 3">
          <img @click="moreKb('/kb/codePractice')" class="notice-bg" src="@/assets/images/scbk-media-1.png" alt="">
        </div>
      </div>
    </div>
    <!-- end tools -->
    <div class="activity">
      <p class="title">
        <img
          class="title-image left"
          src="@/assets/images/title-left.png"
          alt=""
        />
        <span>第一届委员会单位</span>
        <img
          class="title-image right"
          src="@/assets/images/title-right.png"
          alt=""
        />
      </p>
      <p class="titleEN">Members of the First Committee</p>

      <!-- <div class="activity-content">
        <div class="activity-content-left">
          <el-tabs
            style="height: 60px"
            ref="navTabs"
            v-model="tabsActiveName"
            @tab-click="handleClick"
          >
            <el-tab-pane label="峰会"> -->
      <!-- <div class="activity-content-left-list">
                <router-link v-for="(item,key) in summitList" :key="key" :to="'/news/detail?nId='+item.nbId" tag="a" target="_blank">
                  <span>{{item.nbTitle}}</span>
                  <span>{{formatDate(item.nbVisittime)}}</span>
                </router-link>
              </div> -->
      <!-- </el-tab-pane>
            <el-tab-pane label="研讨会"> </el-tab-pane>
            <el-tab-pane label="沙龙"> -->
      <!-- <div class="activity-content-left-list">
                <router-link v-for="(item,key) in summitList" :key="key" :to="'/news/detail?nId='+item.nbId" tag="a" target="_blank">
                  <span>{{item.nbTitle}}</span>
                  <span>{{formatDate(item.nbVisittime)}}</span>
                </router-link>
              </div> -->
      <!-- </el-tab-pane>
            <el-tab-pane label="赛事"> -->
      <!-- <div class="activity-content-left-list">
                <router-link v-for="(item,key) in summitList" :key="key" :to="'/news/detail?nId='+item.nbId" tag="a" target="_blank">
                  <span>{{item.nbTitle}}</span>
                  <span>{{formatDate(item.nbVisittime)}}</span>
                </router-link>
              </div> -->
      <!-- </el-tab-pane>
          </el-tabs>
          <div class="activity-content-left-list">
            <router-link
              v-for="(item, key) in summitList"
              :key="key"
              :to="'/news/detail?nId=' + item.nbId"
              tag="a"
              target="_blank"
            >
              <span>{{ item.nbTitle }}</span>
              <span>{{ formatDate(item.nbVisittime) }}</span>
            </router-link>
          </div>
        </div>
        <div class="activity-content-right">
          <h3>
            <img
              src="../assets/images/activity-right.png"
              width="28"
            />活动与会议
            <div class="more" @click="more('/activity/summit')">更多</div>
          </h3>
          <div class="activity-content-right-list">
            <div
              class="activity-content-right-list-item"
              v-for="(item, key) in activityList"
              :key="key"
            >
              <router-link
                :to="'/news/detail?nId=' + item.nbId"
                tag="a"
                target="_blank"
              >
                <span class="notStarted">未开始</span>
                <span>{{ item.nbTitle }}</span>
                <span>{{ formatDate(item.nbVisittime) }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div> -->

      <ul class="activity-content">
        <li
          class="activity-content-item"
          v-for="item in unitTypeList"
          :key="item.id"
        >
          <div class="name">{{ item.name }}</div>
          <div class="unitList">
            <div class="unit-item" v-for="ele in item.childList" :key="ele.id">
              <div class="unit-item-logo">
                <img
                  v-if="ele.pic"
                  :src="require(`@/assets/images/${ele.pic}`)"
                  alt=""
                />
              </div>
              <p class="unit-item-name">{{ ele.name }}</p>
            </div>
          </div>
        </li>
      </ul>
      <div class="member">
        <a href="javascript:void(0)" @click="moreM('/centigrade/dynamic')"
          >成员动态</a
        >
        <a href="javascript:void(0)" @click="moreM('/centigrade/introduce')"
          >成员权益</a
        >
        <a href="javascript:void(0)" @click="moreM('/centigrade/rights')"
          >申请加入</a
        >
      </div>
    </div>
    <!-- end activity -->
  </div>
</template>

<script>
import {
  selectAreaNotice,
  selectNoticeCarousel,
  selectNoticeDetail,
} from "@/utils/api";
import dayjs from "dayjs";
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      tabsActiveName: "0",
      newsInfo: [],
      summitList: [],
      newsNotice: [],
      activityList: [],
      carouselList: [],
      prevent: 4,
      newsAction: 1,
      unitTypeList: [
        {
          name: "主任委员单位",
          id: 1,
          childList: [
            { name: "华为技术有限公司", pic: "huawei.jpg", id: 11 },
            { name: "曙光信息产业股份有限公司", pic: "shuguang.jpg", id: 12 },
          ],
        },
        {
          name: "副主任委员单位",
          id: 2,
          childList: [
            { name: "中国电子技术标准化研究院", pic: "cndianzi.png", id: 22 },
            { name: "中国软件评测中心", pic: "cnruanjian.png", id: 21 },
            { name: "中国移动通信集团有限公司", pic: "cnmobeil.png", id: 24 },
            { name: "中国工商银行数据中心", pic: "ICBC.jpg", id: 23 },
            { name: "北京海量数据股份有限公司", pic: "bjhailiang.png", id: 25 },
            { name: "中国华录集团有限公司", pic: "cnhualu.png", id: 26 },
          ],
        },
        {
          name: "委员单位",
          id: 3,
          childList: [
            { name: "江苏芯盛智能科技有限公司", pic: "xinsheng.png", id: 31 },
          ],
        },
      ],
      activeId: 1
    };
  },
  methods: {
    newListClick(val) {
      if (val == 1) {
        this.getNews(3);
      } else if (val == 2) {
        this.getNews(4);
      } else {
        this.getNews(5);
      }
      this.newsAction = val;
    },
    // handleClick(tab) {
    //   if (typeof tab !== "number") return;
    //   if (this.prevent === tab + 4) return;
    //   this.getSummit(tab + 4);
    // },
    more(id, nbId = "", isParam = false) {
      let routeData;
      if (nbId) {
        if (isParam) {
          this.$store.commit('SET_NAV_TITLE', '专委新闻')
          sessionStorage.setItem('__DSC_aId', '3')
          routeData = this.$router.resolve({
            path: "/news/detail",
            query: { nId: nbId },
          });
        } else {
          if (this.newsAction == 1) {
            this.$store.commit('SET_NAV_TITLE', '专委新闻')
            sessionStorage.setItem('__DSC_aId', '3')
            routeData = this.$router.resolve({
              path: "/news/detail",
              query: { nId: nbId },
            });
          } else if (this.newsAction == 2) {
            this.$store.commit('SET_NAV_TITLE', '行业动态')
            sessionStorage.setItem('__DSC_aId', '4')
            routeData = this.$router.resolve({
              path: "/news/detail",
              query: { nId: nbId },
            });
          } else {
            this.$store.commit('SET_NAV_TITLE', '政策新闻')
            sessionStorage.setItem('__DSC_aId', '5')
            routeData = this.$router.resolve({
              path: "/news/detail",
              query: { nId: nbId },
            });
          }
        }
      } else {
        if (this.newsAction == 1) {
          this.$store.commit('SET_NAV_TITLE', '专委新闻')
        } else if (this.newsAction == 2) {
          this.$store.commit('SET_NAV_TITLE', '行业动态')
        } else {
          this.$store.commit('SET_NAV_TITLE', '政策新闻')
        }
        routeData = this.$router.resolve({ path: id });
      }
      window.open(routeData.href, "_blank");
    },
    moreKb(id) {
      if (id == '/kb/doc') {
        this.$store.commit('SET_NAV_TITLE', '知识专区')
      } else if (id == '/kb/term') {
        this.$store.commit('SET_NAV_TITLE', '资料库')
      } else if (id == '/kb/codePractice') {
        this.$store.commit('SET_NAV_TITLE', '数存百科')
      }
      let routeData;
      routeData = this.$router.resolve({ path: id });
      window.open(routeData.href, "_blank");
    },
    moreM(id) {
      if (id == '/centigrade/dynamic') {
        this.$store.commit('SET_NAV_TITLE', '成员动态')
      }else if (id == '/centigrade/introduce') {
        this.$store.commit('SET_NAV_TITLE', '成员权益')
      } else {
        this.$store.commit('SET_NAV_TITLE', '申请加入')
      }
      let routeData;
      routeData = this.$router.resolve({ path: id });
      window.open(routeData.href, "_blank");
    },
    goWarn(id) {
      this.activeId = id
      // if (id > 3) {
      //   this.$message({
      //     message: "功能正在建设中",
      //     type: "warning",
      //   });
      // }
    },
    getNews(areaId) {
      selectAreaNotice({
        pageNo: 1,
        pageSize: 4,
        areaId,
      }).then((res) => {
        this.newsInfo = res.data.records;
      });
      // selectAreaNotice({
      //   pageNo: 1,
      //   pageSize: 5,
      //   areaId: 14,
      // }).then((res) => {
      //   this.newsNotice = res.data.records;
      // });
      // selectAreaNotice({
      //   pageNo: 1,
      //   pageSize: 8,
      //   areaId: 5,
      // }).then((res) => {
      //   this.activityList = res.data.records;
      // });
    },
    // getSummit(id) {
    //   this.prevent = id;
    //   selectAreaNotice({
    //     pageNo: 1,
    //     pageSize: 8,
    //     areaId: id,
    //   }).then((res) => {
    //     this.summitList = res.data.records;
    //   });
    // },
    getNoticeCarousel() {
      selectNoticeCarousel().then((res) => {
        res.data.forEach((element) => {
          selectNoticeDetail(element.nbId).then((res) => {
            element.content = res.data.nbContentfors;
          });
        });
        setTimeout(() => {
          this.carouselList = res.data;
        }, 200);
      });
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD");
    },
  },
  computed: {
    isMobile() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|Macintosh|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },
  },
  created() {
  },
  mounted() {
    this.getNews(3);
    // this.getSummit(4);
    this.getNoticeCarousel();
    this.$nextTick(() => {
      this.$refs.navTabs &&
        this.$refs.navTabs.$refs.nav.$nextTick(() => {
          let target = document.getElementsByClassName("el-tabs__item");
          let that = this;
          for (let i = 0; i < target.length; i++) {
            target[i].addEventListener("mouseover", () => {
              that.$refs.navTabs.handleTabClick(i, String(i));
            });
            target[i].addEventListener("click", () => {
              if (i === 0) {
                window.open("/#/activity/summit", "_blank");
              } else if (i === 1) {
                window.open("/#/activity/discuss", "_blank");
              } else if (i === 2) {
                window.open("/#/activity/salon", "_blank");
              } else if (i === 3) {
                window.open("/#/activity/event", "_blank");
              }
            });
          }
        });
    });
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  min-width: 1280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;

  .more {
    font-size: 16px;
    position: absolute;
    font-weight: normal;
    right: 0;
    top: 0;
    cursor: pointer;
  }
}

.title {
  font-size: 38px;
  font-weight: 700;
  color: #000;
  text-align: center;

  span {
    position: relative;
    z-index: 10 !important;
  }

  .title-image {
    width: 69px;
    height: 48px;
    z-index: 8 !important;
    position: relative;
  }

  .left {
    right: -10px;
    top: -10px;
  }

  .right {
    left: -9px;
    bottom: -37px;
  }
}

.titleEN {
  text-align: center;
  font-size: 24px;
  margin-bottom: 40px;
  color: rgba(0, 0, 0, 0.42);
  position: relative;
  z-index: 9;
}

.news-image {
  width: 616px;

  /deep/ .el-carousel {
    border-radius: 14px;
    box-shadow: 1px 3px 5px 0px rgba(0, 0, 0, 0.1),
      /* 右边阴影 */ -1px 3px 5px 0px rgba(0, 0, 0, 0.1);

    /* 底部阴影 */
    .el-carousel__button {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #000;
      opacity: 0.42;
    }

    .is-active .el-carousel__button {
      background-color: #fff;
      width: 31px;
      opacity: 0.9;
      border-radius: 15px;
    }

    .el-carousel__indicators--horizontal {
      left: 50px;
    }
  }

  .news-image-title {
    margin: 20px 20px 10px;
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    color: #000;
    white-space: nowrap;
    /* 确保文本在一行内显示 */
    overflow: hidden;
    /* 超出容器部分隐藏 */
    text-overflow: ellipsis;
    /* 超出部分显示省略号 */
    color: #333333;
  }

  .news-image-content {
    margin: 0 20px;
    font-size: 16px;
    line-height: 30px;
    color: #333333;
    overflow: hidden;
    /* 确保超出的内容被隐藏 */
    text-overflow: ellipsis;
    /* 使用省略号显示超出的文本 */
    display: -webkit-box;
    /* 作为弹性伸缩盒子模型显示 */
    -webkit-line-clamp: 2;
    /* 限制在两行 */
    -webkit-box-orient: vertical;
    /* 垂直排列盒子 */
  }
}

.activity {
  width: 100%;
  background: url("@/assets/images/unitBg.png") no-repeat;
  background-size: cover;
  padding-top: 40px;

  // .activity-content {
  //   display: flex;
  //   padding-bottom: 30px;
  // }
  // .activity-content-left {
  //   width: 694px;
  //   height: 465px;
  //   .activity-content-left-list {
  //     a {
  //       display: flex;
  //       line-height: 30px;
  //       margin-bottom: 20px;
  //       span {
  //         &:nth-child(1) {
  //           width: 580px;
  //           margin-right: 15px;
  //           color: #333;
  //           font-weight: 500;
  //           font-size: 18px;
  //         }
  //         &:nth-child(2) {
  //           color: #000;
  //           font-size: 16px;
  //         }
  //       }
  //     }
  //   }
  //   /deep/ .el-tabs {
  //     .el-tabs__item {
  //       font-size: 20px;
  //       font-weight: 500;
  //       padding: 0;
  //       height: 45px;
  //       padding-right: 100px;
  //     }
  //     .el-tabs__nav-wrap::after {
  //       background: #fff;
  //     }
  //     .is-active {
  //       color: #053780;
  //     }
  //     .el-tabs__active-bar {
  //       background: url(../assets/images/activity-left.png) no-repeat;
  //       background-size: 20px 10px;
  //       background-position: bottom center;
  //       height: 10px;
  //     }
  //   }
  // }
  // .activity-content-right {
  //   margin-left: 55px;
  //   .activity-content-right-list-item {
  //     margin-bottom: 18px;
  //     a {
  //       display: flex;
  //     }
  //     span {
  //       line-height: 32px;
  //       &:nth-child(1) {
  //         width: 68px;
  //         text-align: center;
  //         height: 32px;
  //         line-height: 32px;
  //         border-radius: 10px;
  //         background: #053780;
  //         color: #fff;
  //         margin-right: 10px;
  //       }
  //       &.notStarted {
  //         background: #f17b20;
  //       }
  //       &:nth-child(2) {
  //         width: 340px;
  //         margin-right: 15px;
  //         overflow: hidden;
  //         text-overflow: ellipsis;
  //         white-space: nowrap;
  //         font-weight: 700;
  //         font-size: 18px;
  //         color: #333;
  //       }
  //       &:nth-child(3) {
  //         font-size: 16px;
  //         color: rgba(0, 0, 0, 0.42);
  //       }
  //     }
  //   }
  //   h3 {
  //     color: #053780;
  //     font-size: 20px;
  //     font-weight: 700;
  //     line-height: 30px;
  //     position: relative;
  //     img {
  //       float: left;
  //       margin-right: 7px;
  //     }
  //   }
  // }
  .activity-content {
    width: 1280px;
    margin: 0 auto;
    padding: 0;

    .activity-content-item {
      list-style: none;
      display: flex;
      margin-bottom: 32px;
      border-bottom: 1px solid #d9d9d9;

      .name {
        width: 115px;
        font-size: 18px;
        color: #000;
        font-weight: 700;
        line-height: 27px;
        margin-right: 47px;
      }

      .unitList {
        width: 1137px;
        display: flex;
        flex-wrap: wrap;

        .unit-item {
          height: 130px;
          margin-right: 81.5px;

          .unit-item-logo {
            width: 316px;
            height: 80px;
            border: 1px solid #e0ebfb;
            border-radius: 6px;
            box-shadow: 1px 3px 5px 0px rgba(0, 0, 0, 0.1),
              /* 右边阴影 */ -1px 3px 5px 0px rgba(0, 0, 0, 0.1);
            /* 底部阴影 */
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #fff;
            img {
              max-width: 80%;
              height: 60%;
              object-fit: contain;
            }
          }

          .unit-item-name {
            text-align: center;
            margin: 0;
            color: rgba(0, 0, 0, 0.42);
            font-size: 16px;
            line-height: 24px;
            margin-top: 10px;
          }
        }

        .unit-item:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }

  .member {
    display: flex;
    justify-content: center;
    margin-bottom: 60px;

    a {
      display: block;
      width: 140px;
      height: 40px;
      background-color: #053780;
      color: #fff;
      border-radius: 6px;
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      line-height: 40px;
      margin-right: 60px;
    }

    a:last-child {
      margin-right: 0;
      background-color: #f17b20;
    }
  }
}

.tools {
  width: 100%;
  height: 679px;
  padding: 21px 0;
  background: #eaf8fd;
  background: url("@/assets/images/technologyBg.png") no-repeat;
  background-size: cover;

  .bottom {
    display: flex;
    justify-content: center;

    .notice-content {
      background-image: linear-gradient(to right, #3e4eaa, #053780);
      border-radius: 10px;
      width: 885px;
      height: 397px;
      padding: 10px 20px;
      box-sizing: border-box;
      cursor: pointer;
      position: relative;
      .image {
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        bottom: 0;
      }

      h3 {
        color: #fff;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        text-align: center;
        margin-bottom: 38px;
        position: relative;
        z-index: 2;
      }

      .images {
        display: flex;
        justify-content: center;
        position: relative;
        z-index: 2;

        img {
          width: 151px;
          height: 224px;
          margin-right: 32.5px;
          margin-top: 30px;
        }

        img:last-child {
          margin-right: 0;
        }

        img:nth-child(2) {
          margin-top: 0;
        }
      }

      // a {
      //   display: block;
      //   line-height: 30px;
      //   display: flex;
      //   margin-bottom: 8px;

      //   span {
      //     &:nth-child(1) {
      //       width: 343px;
      //       font-size: 18px;
      //       color: #333;
      //       font-weight: 500;
      //       overflow: hidden;
      //       text-overflow: ellipsis;
      //       white-space: nowrap;
      //       margin-right: 30px;
      //     }
      //     &:nth-child(2) {
      //       font-size: 16px;
      //       color: rgba(0, 0, 0, 0.42);
      //     }
      //   }
      // }
    }

    .query {
      margin-right: 70px;
      width: 320px;

      .query-img {
        width: 320px;
        height: 100px;
        .image {
          width: 78px;
        }
      }

      a {
        display: flex;
        align-items: center;
        position: relative;
        width: 320px;
        height: 100px;
        border-radius: 14px;
        background-color: #fff;
        margin-right: 9px;
        margin-bottom: 50px;
        padding: 28px 0 28px 30px;
        overflow: hidden;
        box-sizing: border-box;
        box-shadow: 1px 3px 5px 0px rgba(0, 0, 0, 0.1),
          /* 右边阴影 */ -1px 3px 5px 0px rgba(0, 0, 0, 0.1);
        &.is-active{
          background-image: linear-gradient(to right, #3580ed, #053780);
          .media{
            background: #fff;
          }
          p {
            color: #fff;
          }
          .image{
            color: rgba(255,255,255,0.42);
          }
        }
        /* 底部阴影 */
        .media {
          width: 44px;
          height: 44px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #cee3ff;
          margin-right: 20px;

          .icon {
            font-size: 30px;
            color: #053780;
          }
        }

        p {
          color: #000000;
          font-size: 18px;
          font-weight: 700;
          line-height: 27px;
        }

        .image {
          font-size: 70px;
          color: rgba(5,55,128,0.15);
          position: absolute;
          z-index: 1;
          right: 5px;
          bottom: 2px;
        }
      }

      .query-tool {
        text-align: center;
        margin-top: 10px;

        span {
          display: inline-block;
          width: 10px;
          height: 10px;
          background: rgba(0, 0, 0, 0.42);
          border-radius: 50%;
          margin-right: 10px;

          &.query-tool-check {
            background: #053780;
            width: 31px;
            border-radius: 5px;
          }
        }
      }

      // h3 {
      //   height: 30px;
      //   font-size: 20px;
      //   line-height: 30px;
      //   font-weight: 700;
      //   margin: 0;
      //   img {
      //     float: left;
      //     margin-right: 10px;
      //   }
      // }
    }

    .notice {
      width: 885px;
      margin-right: 0;
      .notice-bg{
        display: block;
        width: 100%;
        height: auto;
        border-radius: 10px;
        cursor: pointer;
      }
    }
  }
}

.news {
  width: 100%;
  background: url("@/assets/images/newsBg.png") no-repeat;
  background-size: 58% 100%;
  background-position: center center;
  padding: 34px 0px 20px;

  .bottom {
    display: flex;
    justify-content: center;

    img {
      border-radius: 18px;
    }

    .news-list {
      width: 614px;
      margin-left: 50px;

      .news-list-title {
        display: flex;
        padding-left: 0;
        margin: 0 0 27px;

        li {
          list-style: none;
          width: 160px;
          height: 48px;
          margin-right: 30px;
          border-radius: 10px;
          font-size: 18px;
          line-height: 48px;
          text-align: center;
          color: #000000;
          background-image: #fff;
          cursor: pointer;
          box-shadow: 1px 3px 5px 0px rgba(0, 0, 0, 0.1),
            /* 右边阴影 */ -1px 3px 5px 0px rgba(0, 0, 0, 0.1);
          /* 底部阴影 */
        }

        .is-action {
          color: #fff;
          background-image: linear-gradient(to right, #3580ed, #053780);
        }
      }

      .news-list-content {
        width: 612px;
        height: 356px;
        margin: 0 auto;
        // overflow: auto;
        cursor: pointer;

        a {
          display: block;
          line-height: 30px;
          margin-bottom: 13px;
          border: 1px solid #e0ebfb;
          border-radius: 10px;
          padding: 7px 19px;
          box-sizing: border-box;
          box-shadow: 1px 3px 5px 0px rgba(5, 55, 128, 0.15),
            /* 右边阴影 */ -1px 3px 5px 0px rgba(5, 55, 128, 0.15);
          /* 底部阴影 */
          background-image: linear-gradient(to bottom, #f3f5f9, #ffffff);

          p {
            margin: 0;
            width: 100%;
            line-height: 30px;

            &:nth-child(1) {
              font-size: 18px;
              font-weight: 700;
              color: #000000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            &:nth-child(2) {
              font-size: 16px;
              color: rgba(0, 0, 0, 0.42);
            }
          }
        }
      }
    }
  }

  .news-more {
    width: 180px;
    height: 40px;
    font-size: 16px;
    font-weight: 600;
    margin: 60px auto;
    color: #053780;
    border: 1px solid #053780;
    border-radius: 10px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
}
.no-data-wrap{
  :deep(.el-empty){
    padding: 28px 0;
  }
}
</style>
